'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = mockResources;

var _fetchMock = require('fetch-mock');

var _fetchMock2 = _interopRequireDefault(_fetchMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mockResources(resources) {
  (0, _keys2.default)(resources).forEach(function (uri) {
    (0, _keys2.default)(resources[uri]).forEach(function (method) {
      console.log('Mock ' + method + ':' + uri);
      _fetchMock2.default.mock(new RegExp(uri.replace(/\*/g, '.*').replace(/\?/, '\\?')), {
        body: resources[uri][method],
        status: resources[uri][method].errors ? 400 : 200
      }, { method: method });
    });
  });
} // mockResources is only used in dev mode
/* eslint import/no-extraneous-dependencies: "off" */
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/trv-fed-mocked-fetch.js
// module id = 1251
// module chunks = 0